import {APP_INITIALIZER, NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {BrowserModule} from '@angular/platform-browser';
import { AgGridModule } from 'ag-grid-angular';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ExtraOptions, PreloadAllModules, RouterModule, UrlSerializer} from '@angular/router';
import {FuseModule} from '@fuse';
import {FuseConfigModule} from '@fuse/services/config';
import {FuseMockApiModule} from '@fuse/lib/mock-api';
import {CoreModule} from 'app/core/core.module';
import {appConfig} from 'app/core/config/app.config';
import {mockApiServices} from 'app/mock-api';
import {LayoutModule} from 'app/layout/layout.module';
import {AppComponent} from 'app/app.component';
import {appRoutes} from 'app/app.routing';
import { CustomUrlSerializer } from './CustomUrlSerializer';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

//import { HttpClient } from '@angular/common/http';
//import { IGovService, configFactory } from './shared/services/igov.service';
import {NgIdleModule} from '@ng-idle/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LoginGuard } from './shared/guard/login.guard';
import { EDELGATECalendarService } from './shared/services/e-delegate-calendar.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { EnvironmentLoader } from '../environments/utils/environment-loader.util';
import { CognitoUtil } from './shared/services/cognito.service';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};
export function cognitoUtilFactory(): CognitoUtil {
    return new CognitoUtil({
        region: EnvironmentLoader.environment.region,
        identityPoolId: EnvironmentLoader.environment.identityPoolId,
        userPoolId: EnvironmentLoader.environment.userPoolId,
        clientId: EnvironmentLoader.environment.clientId,
        endpoint: EnvironmentLoader.environment.cognito_idp_endpoint,
    });
}
// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, "/assets/i18n/", ".json");
}


@NgModule({
    declarations: [
        AppComponent,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: () => () =>
                EnvironmentLoader.loadEnvironment().then(() => {
                    // console.log('✅ Env ready');
                }),
            multi: true,
        },
        {
            provide: CognitoUtil,
            useFactory: cognitoUtilFactory,
        },
        LoginGuard,
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        EDELGATECalendarService,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
              }

        }),
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        AgGridModule,

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        MatButtonModule,
        MatExpansionModule,
        MatDialogModule,
        NgIdleModule.forRoot()
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
